import { type IDropdownItem, type IIconsVector } from 'shared/ui'
import {
  type IResponseConversationsFilter,
  type IResponseConversationsFilterKey,
} from 'entities/Conversation/api/types'
import { type FiltersStore } from 'features/DropdownFilter'

export const FiltersItems = (
  items: IResponseConversationsFilter[],
  store: FiltersStore
): IDropdownItem[] => {
  return items.map((item) => {
    let icon: IIconsVector = 'inboxOpen'

    if (item.key === 'open') icon = 'inboxOpen'
    if (item.key === 'unread') icon = 'chatUnread'
    if (item.key === 'assigned') icon = 'userFilled'
    if (item.key === 'mentions') icon = 'users'
    if (item.key === 'unassigned') icon = 'userLine'
    if (item.key === 'scheduled') icon = 'clock'
    if (item.key === 'draft') icon = 'edit'
    if (item.key === 'outbound') icon = 'broadcasts'
    if (item.key === 'closed') icon = 'check2'
    if (item.key === 'pending') icon = 'unanswered'
    if (item.key === 'nocalls') icon = 'textInput2'

    return {
      id: item.key,
      label: item.label,
      iconL: icon,
      active: store.filter?.key === item.key,
    }
  })
}

export const FiltersAction = (item: IDropdownItem, store: FiltersStore) => {
  const id = item.id as IResponseConversationsFilterKey

  if (item.id === store.filter?.key) return

  store.setFilter(id)
}
